module.exports = __webpack_public_path__ + "static/media/ico_simulation_category_faces.98bb14eb.png";